import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledIconButton = styled(IconButton)`
    .SWReactIcons {
        margin-right: 4px;
    }
`;

export const StyledButtonContainer = styled(Flex)`
    justify-content: center;
`;
